import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'a-menu',
  templateUrl: './a-menu.component.html',
  styleUrls: ['./a-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AMenuComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
